import { Card, CardContent, makeStyles, TextField, MenuItem, Select, FormControl, InputLabel, Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useNotification } from '../../../contexts/Notification';
import Fetcher, { URLBuild } from '../../../services/fetcher';
import settings from '../../../settings';
import { FiltersInterface, Prices, subStatus } from '../consts';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    flexFlow: 'column'
  },
  filters: {
    display: 'flex',
	  justifyContent: 'space-around',
	  alignContent: 'center'
  },
  customer: {
    display: 'flex',
    flexDirection: 'row'
  },
  priceSelect: {
    justifyContent: 'flex-start',
    minWidth: 250,
  },
  status: {
    justifyContent: 'flex-start',
    minWidth: 250,
  }
}));

interface Props {
  onFiltersUpdated: Function
};

const Filters = (props: Props) => {
  const classes = useStyles();
  const [price, setPrice] = useState<String>('all');
  const [prices, setPrices] = useState<Prices[]>([]);
  const [status, setStatus] = useState<String>('all');
  const [customer, setCustomer] = useState<String>('');
  const [validCustomer, setValidCustomer] = useState<boolean>(true);
  const [filters, setFilters] = useState<FiltersInterface>({});
  const notification = useNotification();

  useEffect(() => {
    Fetcher.get(
      URLBuild(settings.PaymentProvider.paymentApi + '/stripe/prices/list', { type: 'recurring' })
    ).then(data => {
      setPrices(data.data.map((row: any) => {
        return {id: row.id, displayValue: row.nickname};
      }));
    }).catch((e: Error) => {
      notification.notify(e.message, "error");
      console.error(e);
    });
  }, []);

  useEffect(() => {
    if (filters.price === 'all')
      delete filters.price;
    props.onFiltersUpdated(filters); 
  }, [filters]);

  const handlePriceChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilters({...filters, price: event.target.value as string});
    setPrice(event.target.value as string);
  };

  const handleCustomerIdChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: String = event.target.value as String;
    setCustomer(value);
    setValidCustomer(
      value === null || value === undefined || value === '' || value.startsWith('cus_')
    );
  };

  const handleStatusChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilters({...filters, status: event.target.value as string});
    setStatus(event.target.value as string);
  };

  const handleSearchButton = (_:any) => {
    if (customer.length === 0) {
      setFilters((prevFilters) => {
        if (prevFilters.customer)
          delete prevFilters['customer'];
        return {...prevFilters};
      });
    }
    else
      setFilters({...filters, customer: customer as string});
  };

  return (
    <div className={classes.container}>
      <Card>
        <CardContent>
          <div className={classes.filters}>
            <div className={classes.customer}>
              <TextField
                error={!validCustomer}
                id="customerId"
                label="ID Client Stripe"
                variant="outlined"
                placeholder="cus_****"
                onChange={handleCustomerIdChange}
                value={customer}
              />
              <Button variant="outlined" color="primary" onClick={handleSearchButton} disabled={!validCustomer}>Rechercher</Button>
            </div>
            <FormControl variant="outlined" className={classes.priceSelect}>
              <InputLabel id="priceLabel">Formule</InputLabel>
              <Select
                labelId="priceLabel"
                id="priceIdSelect"
                value={price}
                onChange={handlePriceChange}
                label="Formule"
                disabled={prices.length === 0}
              >
                <MenuItem value='all'>Tous</MenuItem>
                {prices.map(currentPrice =>
                  <MenuItem key={currentPrice.id} value={currentPrice.id}>{currentPrice.displayValue}</MenuItem>
                )}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.status}>
              <InputLabel id="statusLabel">Status</InputLabel>
              <Select
                labelId="statusLabel"
                id="statusSelect"
                value={status}
                onChange={handleStatusChange}
                label="Status"
              >
                {subStatus.map(currentStatus =>
                  <MenuItem key={currentStatus.value} value={currentStatus.value}>{currentStatus.displayValue}</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default Filters;